import templates from './agentTemplates.json';

// Starter bot_config presets offered when creating an AI Agent. The JSON is also
// validated server-side (spec/services/ai_bot/config_validate_templates_spec.rb).
// Icon classes live here (not in the JSON) so Tailwind's content scan picks them up.
const TEMPLATE_ICONS = {
  blank: 'i-lucide-file',
  general_cs: 'i-lucide-headset',
  gaming_cs: 'i-lucide-gamepad-2',
};

export const AGENT_TEMPLATES = templates.map(template => ({
  ...template,
  icon: TEMPLATE_ICONS[template.key],
}));

export const DEFAULT_TEMPLATE_KEY = 'blank';

// The form's persona fields (name, brand, salutation, language) win over the preset.
export const buildTemplateConfig = (templateKey, persona) => {
  const template =
    AGENT_TEMPLATES.find(item => item.key === templateKey) ||
    AGENT_TEMPLATES.find(item => item.key === DEFAULT_TEMPLATE_KEY);
  const preset = template.bot_config;

  return {
    ...preset,
    version: 1,
    persona: { ...(preset.persona || {}), ...persona },
  };
};
